import { Box, Switch, Typography } from '@mui/material';
import React from 'react';

function EscoSwitch(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography>No</Typography>
            <Switch checked = {props.checked} onChange = {props.onChange}/>
            <Typography>Sí</Typography>
        </Box>
    );
}

export default EscoSwitch;